export default __webpack_public_path__ + "static/media/brawezone.9aa75cd6.svg";